<template>
    <div>
    	<label>Country code</label>
            <v-select name="country_code" :searchable="true" label="item_data"
            :options="country_code_search" v-model="cntry_code"
                    v-validate="rules">
                <!-- <template slot="option"  slot-scope="option">
                    <span></span>
                    {{ option.name }} {{option.label}}
                </template> -->
            </v-select>
            <span class="input-error-msg">{{ errors.first('country_code') }}</span>
    </div>
</template>
<script>
export default {
    props:['form','country_codes','section','rule'],
    data (){
        return{

        }
    },
    watch:{
        cntry_code: function(val){
        }
    },
    mounted: function(){
    },
    computed:{
        rules: function(){
            if(this.rule == 'required'){
                return 'required'
            }else{
                return ''
            }

        },
        cntry_code:{
            get(){ 
                return this.form.country_code
            },
           set(val){
                this.$validator.validateAll('country_code').then((result) => {
                    if(result){
                        if(this.section == 'existin-provider'){
                            this.$emit('countryInput', val)
                        }
                        if(this.section == 'course-create'){
                            this.$emit('countryInputCourse', val)
                        }
                        if(this.section == 'new-provider'){
                            this.$emit('countryInputNewProvider', val)
                        }
                    }
                })
            }
        },
        country_code_search: function(){
            let country_code_search_= this.country_codes

            for(let i in this.country_codes){
                country_code_search_[i].item_data = this.country_codes[i].name + ' ' + this.country_codes[i].value
            }
            return country_code_search_
        }
    },
    methods:{

    }
  
}
</script>



// WEBPACK FOOTER //
// src/components/shared/inputs/PhoneCountryCode.vue